import React from 'react'
import { AppReducerAction, WiserMode } from './state/AppState'
import { UserType } from './types/userTypes'
import { ProductSeries } from './types/productTypes'

export interface ConfiguratorAppContextShape {
  onClickHome: () => void
  onClickList: () => void
  onClickShareList: () => void
  onClickShareBom: () => void
  onClickAccount: () => void
  onClickWallColor: () => void
  dispatch: React.Dispatch<AppReducerAction>
  listShown: boolean
  sharingListShown: boolean
  sharingBomShown: boolean
  wallColorShown: boolean
  listName: string
  listId: string
  userType: UserType | null
  wallColor: string
  debugMode: boolean
  listAccessible: boolean
  renameListTutorialDismissed: boolean
  typeSelectorTutorialDismissed: boolean
  shouldShowCustomiseHint: boolean
  shouldShowCashSales: boolean
  optionalWiserMode: WiserMode | null
  selectedProductSeries: ProductSeries | null
  moreInfo: boolean
  /** @Deprecated */ isAuthenticated: boolean
  shouldShowPackQuantityInCustomise: boolean
  userTypeSelectionEnabled: boolean
  proSeriesEnabled: boolean
  addingRoomsEnabled: boolean
  hasOptedOutOfWiserHubPrompt: boolean
  hasOptedOutOfMomentarySwitchesPrompt: boolean
}

const NoOp = () => { return }

const ConfiguratorAppContext = React.createContext<ConfiguratorAppContextShape>({
  onClickHome: NoOp,
  onClickList: NoOp,
  onClickAccount: NoOp,
  onClickShareList: NoOp,
  onClickShareBom: NoOp,
  onClickWallColor: NoOp,
  dispatch: NoOp,
  moreInfo: false,
  listShown: false,
  sharingListShown: false,
  sharingBomShown: false,
  wallColorShown: false,
  listName: '',
  listId: '',
  userType: null,
  wallColor: '#fff',
  debugMode: false,
  listAccessible: false,
  renameListTutorialDismissed: false,
  typeSelectorTutorialDismissed: false,
  shouldShowCustomiseHint: false,
  shouldShowCashSales: false,
  optionalWiserMode: null,
  selectedProductSeries: ProductSeries.Iconic,
  isAuthenticated: false,
  shouldShowPackQuantityInCustomise: true,
  userTypeSelectionEnabled: false,
  proSeriesEnabled: false,
  addingRoomsEnabled: false,
  hasOptedOutOfWiserHubPrompt: false,
  hasOptedOutOfMomentarySwitchesPrompt: false,
})

export default ConfiguratorAppContext
